import { Box, Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { cleanObject } from "../utils/cleanobject";
import { BASE_URL } from "../utils/config";
import { formLabel } from "../utils/formFieldLabels";
import { isEnglish, maxLength } from "../utils/methods";
import "./AdmissionForm.css";
import CommonAccordion from "./CommonAccordion";
import ErrorMessage from "./ErrorMessage";
import Input from "./Input";
import "./phoneInput.css";
import Spinner from "./Spinner";

const MissingForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [testType, setTestType] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Initial form state
    const [formData, setFormData] = useState({
        firstName: { value: "" },
        scientificMarks: {
            value: [
                {
                    physics: { value: "" },
                    chemistry: { value: "" },
                    biology: { value: "" },
                    average: { value: 0 }
                }
            ]
        },
        test: {
            testScore: { value: "" },
            testDate: { value: "" },
            testType: {
                value: "IELTS",
                option: [
                    // { value: "NA", label: "Not Applicable" },
                    { value: "IELTS", label: "IELTS" },
                    { value: "TOEFL", label: "TOEFL" },
                    { value: "other", label: "Other" }
                ]
            }
        },
        testTypeOtherNote: { value: "" },
        family: {
            motherDepartment: { value: "" },
            motherExactJob: { value: "" },
            fatherDepartment: { value: "" },
            fatherExactJob: { value: "" },
        },
    });

    const [errors, setErrors] = useState({
        scientificMarksPhysics: "",
        scientificMarksChemistry: "",
        scientificMarksBiology: "",
        testScore: "",
        testDate: "",
        testType: "",
        testTypeOtherNote: "",
        motherDepartment: "",
        motherExactJob: "",
        fatherDepartment: "",
        fatherExactJob: "",
    });



    const validateForm = () => {
        const newErrors = {};

        const { physics, chemistry, biology, average } = formData.scientificMarks.value[0];

        // Scientific Marks
        if (!physics.value) newErrors.scientificMarksPhysics = "Physics mark is required.";
        if (!chemistry.value) newErrors.scientificMarksChemistry = "Chemistry mark is required.";
        if (!biology.value) newErrors.scientificMarksBiology = "Biology mark is required.";

        // Test Type
        const testType = formData.test.testType.value;

        if (testType !== "NA") {
            if (!formData.test.testScore.value) {
                newErrors.testScore = "Test score is required.";
            }
            if (!formData.test.testDate.value) {
                newErrors.testDate = "Test date is required.";
            }
        }

        if (testType === "other" && !formData.testTypeOtherNote.value.trim()) {
            newErrors.testTypeOtherNote = "Please specify the test type.";
        }

        // Family Info
        if (!formData.family.motherDepartment.value.trim()) {
            newErrors.motherDepartment = "Mother's department is required.";
        }
        if (!formData.family.motherExactJob.value.trim()) {
            newErrors.motherExactJob = "Mother's job is required.";
        }
        if (!formData.family.fatherDepartment.value.trim()) {
            newErrors.fatherDepartment = "Father's department is required.";
        }
        if (!formData.family.fatherExactJob.value.trim()) {
            newErrors.fatherExactJob = "Father's job is required.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // Fetch student data
    const getStudent = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${BASE_URL}/student/admission/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const json = await response.json();
            console.log(json.data);
            if (json.status) {
                const data = json.data;
                const updatedFormData = {
                    firstName: { value: data?.firstName || "" },
                    scientificMarks: {
                        value: [
                            {
                                physics: { value: data?.scientific_sub?.physics || "" },
                                chemistry: { value: data?.scientific_sub?.chemistry || "" },
                                biology: { value: data?.scientific_sub?.biology || "" },
                                average: {
                                    value: (
                                        (parseFloat(data?.scientific_sub?.physics || 0) +
                                            parseFloat(data?.scientific_sub?.chemistry || 0) +
                                            parseFloat(data?.scientific_sub?.biology || 0)) / 3
                                    ) || 0
                                }
                            }
                        ]
                    },
                    test: {
                        testScore: { value: data?.english_test?.score || "" },
                        testDate: { value: data?.english_test?.date || "" },
                        testType: {
                            value: data?.english_test?.type || "IELTS",
                            option: [
                                // { value: "NA", label: "Not Applicable" },
                                { value: "IELTS", label: "IELTS" },
                                { value: "TOEFL", label: "TOEFL" },
                                { value: "other", label: "Other" }
                            ]
                        }
                    },
                    testTypeOtherNote: { value: data?.testTypeOtherNote || "" },
                    family: {
                        motherDepartment: { value: data?.family?.motherDepartment || "" },
                        motherExactJob: { value: data?.family?.motherExactJob || "" },
                        fatherDepartment: { value: data?.family?.fatherDepartment || "" },
                        fatherExactJob: { value: data?.family?.fatherExactJob || "" },
                    }
                };
                setFormData(updatedFormData);

            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        document.title = "AUMS • Academic";
        console.log(id);
        getStudent();
    }, [id]);

    const submitForm = async () => {
        if (!validateForm()) {
            toast.error("Please correct the errors before submitting.");
            return;
        }
        setIsLoading(true);
        try {
            console.log(formData);
            console.log(formData.firstName);
            const uploadData = {
                firstName: formData.firstName.value,
                family: {
                    fatherDepartment: formData.family.fatherDepartment.value,
                    fatherExactJob: formData.family.fatherExactJob.value,
                    motherDepartment: formData.family.motherDepartment.value,
                    motherExactJob: formData.family.motherExactJob.value,
                },

                scientificSubject: {
                    physics: formData.scientificMarks.value[0].physics.value,
                    chemistry: formData.scientificMarks.value[0].chemistry.value,
                    biology: formData.scientificMarks.value[0].biology.value,
                    average: formData.scientificMarks.value[0].average.value
                },
                englishTest: {
                    date:
                        formData.test.testType.value === "NA"
                            ? null
                            : formData.test.testDate.value,
                    score:
                        formData.test.testType.value === "NA"
                            ? null
                            : formData.test.testScore.value,
                    type: formData.test.testType.value,
                    otherNote:
                        formData.test.testType.value === "other"
                            ? formData.testTypeOtherNote.value
                            : null
                },

            };
            const cleaned = cleanObject(uploadData);
            const response = await fetch(
                `${BASE_URL}/student/admission/${id}`,
                {
                    method: "PATCH",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ ...cleaned })
                }
            );
            const result = await response.json();
            if (result.status) {
                console.log("RESULT", result);
                toast.error("Form updated successfully!");
                navigate("/");
            } else {
                toast.error("Form submission failed!");
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("Form submission failed!", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = (e, section, field, index = null, subfield = null) => {
        const value = e.target.value;

        setFormData((prev) => {
            const updated = structuredClone(prev);
            if (index !== null && subfield !== null) {
                updated[section].value[index][subfield].value = value;
            } else if (field) {
                updated[section][field].value = value;
            } else {
                updated[section].value = value;
            }
            return updated;
        });
    };

    const handleMarksChange = (index, subject, value) => {
        setFormData((prev) => {
            const updated = structuredClone(prev); // or JSON.parse(JSON.stringify(prev))
            const marks = updated.scientificMarks.value[index];

            marks[subject].value = value;

            const numVals = ["physics", "chemistry", "biology"].map(
                (key) => parseFloat(marks[key].value) || 0
            );

            marks.average.value = numVals.reduce((sum, val) => sum + val, 0) / 3;

            return updated;
        });
    };


    return (
        <>
            <Box sx={{ gap: "10rem px-5" }}>
                <Box
                    sx={{
                        display: "flex",
                        fontWeight: "bold",
                        justifyContent: "space-between",
                        backgroundColor: "#b60041",
                        color: "white",
                        width: "100%",
                        padding: "1rem"
                    }}
                >
                    <span>{formLabel.headings.academicPageTitle.english}</span>
                    <span>{formLabel.headings.academicPageTitle.arabic}</span>
                </Box>

                <Box>
                    <CommonAccordion
                        defaultExpanded={true}
                        arabicLabel={formLabel.headings.academicPageTitle.arabic}
                        englishLabel={formLabel.headings.academicPageTitle.english}
                    >
                        <TableContainer component={Paper} className="mt-4">
                            <Table sx={{ minWidth: 650 }} aria-label="scientific table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center"><strong>Physics</strong></TableCell>
                                        <TableCell align="center"><strong>Chemistry</strong></TableCell>
                                        <TableCell align="center"><strong>Biology</strong></TableCell>
                                        <TableCell align="center"><strong>Average</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {formData.scientificMarks.value.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell align="center">
                                                <Input
                                                    type="number"
                                                    value={row.physics.value}
                                                    handleChange={(e) => {
                                                        if (maxLength(e, 5)) return;
                                                        handleChange(e, "scientificMarks", "value", index, "physics");
                                                        handleMarksChange(index, "physics", e.target.value);
                                                    }}
                                                />
                                                {errors.scientificMarksPhysics && (
                                                    <ErrorMessage errorMessage={errors.scientificMarksPhysics} />
                                                )}
                                            </TableCell>

                                            <TableCell align="center">
                                                <Input
                                                    type="number"
                                                    value={row.chemistry.value}
                                                    handleChange={(e) => {
                                                        if (maxLength(e, 5)) return;
                                                        handleChange(e, "scientificMarks", "value", index, "chemistry");
                                                        handleMarksChange(index, "chemistry", e.target.value);
                                                    }}
                                                />
                                                {errors.scientificMarksChemistry && (
                                                    <ErrorMessage errorMessage={errors.scientificMarksChemistry} />
                                                )}
                                            </TableCell>

                                            <TableCell align="center">
                                                <Input
                                                    type="number"
                                                    value={row.biology.value}
                                                    handleChange={(e) => {
                                                        if (maxLength(e, 5)) return;
                                                        handleChange(e, "scientificMarks", "value", index, "biology");
                                                        handleMarksChange(index, "biology", e.target.value);
                                                    }}
                                                />
                                                {errors.scientificMarksBiology && (
                                                    <ErrorMessage errorMessage={errors.scientificMarksBiology} />
                                                )}
                                            </TableCell>

                                            <TableCell align="center">
                                                {row.average.value !== "" && row.average.value !== 0
                                                    ? Math.floor(row.average.value * 100) / 100
                                                    : ""}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CommonAccordion>
                </Box>

                <CommonAccordion title="English Proficiency Test">
                    <TableContainer component={Paper} className="mt-4">
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell><strong>English Proficiency Test</strong></TableCell>
                                    <TableCell align="right"><strong>Score</strong></TableCell>
                                    <TableCell align="right"><strong>Date</strong></TableCell>
                                    <TableCell align="right"><strong>Test Type</strong></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell />
                                    <TableCell align="right">
                                        <Input
                                            type="number"
                                            value={formData.test.testScore.value}
                                            handleChange={(e) => handleChange(e, "test", "testScore")}
                                            disabled={formData.test.testType.value === "NA"}
                                        />
                                        {errors.testScore && <ErrorMessage errorMessage={errors.testScore} />}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Input
                                            type="date"
                                            value={formData.test.testDate.value}
                                            handleChange={(e) => {
                                                if (new Date(e.target.value).getFullYear() > 2099) return;
                                                handleChange(e, "test", "testDate");
                                            }}
                                            disabled={formData.test.testType.value === "NA"}
                                        />
                                        {errors.testDate && <ErrorMessage errorMessage={errors.testDate} />}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Input
                                            select
                                            type="select"
                                            option={formData.test.testType.option}
                                            value={formData.test.testType.value}
                                            handleChange={(e) => {
                                                handleChange(e, "test", "testType");
                                                setTestType(e.target.value);
                                            }}
                                        />
                                        {errors.testType && <ErrorMessage errorMessage={errors.testType} />}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                        </Table>
                    </TableContainer>

                    {testType === "other" && (
                        <div className="w-full mt-3">
                            <div className="flex items-center justify-between">
                                <p className="my-2 text-gray-500 font-semibold">Please specify</p>
                                {errors.testTypeOtherNote && (
                                    <ErrorMessage alignRight="text-right" errorMessage={errors.testTypeOtherNote} />
                                )}
                            </div>
                            <textarea
                                placeholder="Describe"
                                value={formData.testTypeOtherNote.value}
                                onChange={(e) => handleChange(e, "testTypeOtherNote")}
                                className="w-full h-24 resize-none rounded-lg border border-gray-400 outline-none px-3 py-2"
                            />
                        </div>
                    )}
                </CommonAccordion>

                <CommonAccordion
                    defaultExpanded={true}
                    arabicLabel={formLabel.headings.familyDetailsArabic}
                    englishLabel={formLabel.headings.familyDetailsEnglish}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Input
                                value={formData.family.motherDepartment.value}
                                handleChange={(e) => {
                                    if (!isEnglish(e)) return;
                                    handleChange(e, "family", "motherDepartment");
                                }}
                                englishLabel={formLabel.family.motherDepartment.english}
                                arabicLabel={formLabel.family.motherDepartment.arabic}
                            />
                            {errors.motherDepartment && (
                                <ErrorMessage errorMessage={errors.motherDepartment} />
                            )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Input
                                value={formData.family.motherExactJob.value}
                                handleChange={(e) => {
                                    if (!isEnglish(e)) return;
                                    handleChange(e, "family", "motherExactJob");
                                }}
                                englishLabel={formLabel.family.motherExactJob.english}
                                arabicLabel={formLabel.family.motherExactJob.arabic}
                            />
                            {errors.motherExactJob && (
                                <ErrorMessage errorMessage={errors.motherExactJob} />
                            )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Input
                                value={formData.family.fatherDepartment.value}
                                handleChange={(e) => {
                                    if (!isEnglish(e)) return;
                                    handleChange(e, "family", "fatherDepartment");
                                }}
                                englishLabel={formLabel.family.fatherDepartment.english}
                                arabicLabel={formLabel.family.fatherDepartment.arabic}
                            />
                            {errors.fatherDepartment && (
                                <ErrorMessage errorMessage={errors.fatherDepartment} />
                            )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Input
                                value={formData.family.fatherExactJob.value}
                                handleChange={(e) => {
                                    if (!isEnglish(e)) return;
                                    handleChange(e, "family", "fatherExactJob");
                                }}
                                englishLabel={formLabel.family.fatherExactJob.english}
                                arabicLabel={formLabel.family.fatherExactJob.arabic}
                            />
                            {errors.fatherExactJob && (
                                <ErrorMessage errorMessage={errors.fatherExactJob} />
                            )}
                        </Grid>
                    </Grid>
                </CommonAccordion>

                {/* Submit Button */}
                <Box className="text-center mt-6">
                    <button
                        onClick={submitForm}
                        className="bg-[#b60041] hover:bg-blue-600 px-6 py-3 text-white font-bold rounded"
                    >
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </Box>

            </Box>
            {isLoading && <Spinner />}
        </>
    );
};

export default MissingForm;
